import styled from 'styled-components'

const ContainerStyle = styled.section.attrs({})`
	padding-left: var(--containerPadding);
	padding-right: var(--containerPadding);
	margin-right: auto;
	margin-left: auto;
	width: 100%;

	&.large {
		padding-left: var(--containerLargePadding);
		padding-right: var(--containerLargePadding);
	}
`
export default ContainerStyle
